<template>
  <div class="flex flex-col gap-4">
    <div class="grid gap-4" :class="columnsClass">
      <div
        v-for="(indikator, index) in indikatoren"
        :key="indikator.id"
        class="bg-surface-container-low rounded-large flex flex-col gap-2 p-4"
      >
        <span class="text-body-large inline-flex grow"
          ><span
            class="text-on-primary-container text-title-small bg-primary-container rounded-small mr-2 inline-flex h-5.5 min-w-5.5 shrink-0 items-center justify-center p-1 text-center"
            >{{ index + 1 }}</span
          >...{{ indikator.text }}</span
        >
        <IndikatorHistogram :items="barsFor(indikator.id)" :max-answers="maxAnswers" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import type { IndikatorAnswer, LessonScaleItem } from '../models/teacher-assessment'
  import IndikatorHistogram from './IndikatorHistogram.vue'

  const props = defineProps<{
    indikatoren: ReadonlyArray<{
      readonly id: string
      readonly number: number
      readonly text: string
    }>
    scaleItems: ReadonlyArray<LessonScaleItem>
    members: ReadonlyArray<{
      readonly answers: ReadonlyArray<IndikatorAnswer>
      readonly teacherAnswers: ReadonlyArray<IndikatorAnswer>
    }>
    showTeacher: boolean
  }>()

  const columnsClass = computed(() =>
    props.indikatoren.length % 3 === 1 ? 'grid-cols-2' : 'grid-cols-3',
  )

  const countFor = (indikatorId: string, value: number, source: 'answers' | 'teacherAnswers') =>
    props.members.reduce((total, member) => {
      const answer = member[source].find((item) => item.indikatorId === indikatorId)
      return answer?.value === value ? total + 1 : total
    }, 0)

  const barsFor = (indikatorId: string) =>
    props.scaleItems.map((item) => ({
      value: item.value,
      count: countFor(indikatorId, item.value, 'answers'),
      ...(props.showTeacher
        ? { teacherCount: countFor(indikatorId, item.value, 'teacherAnswers') }
        : {}),
    }))

  const maxAnswers = computed(() =>
    props.indikatoren.reduce((max, indikator) => {
      const indikatorMax = props.scaleItems.reduce((inner, item) => {
        const student = countFor(indikator.id, item.value, 'answers')
        const teacher = props.showTeacher ? countFor(indikator.id, item.value, 'teacherAnswers') : 0
        return Math.max(inner, student, teacher)
      }, 0)
      return Math.max(max, indikatorMax)
    }, 0),
  )
</script>
